module.exports = __webpack_public_path__ + "img/not-found-vk-usa.335c302b.svg";